import { ContactResetPasswordResponseDTO, ContactResetPasswordDTO } from "@/services/AuthService.interface"
import email from "@/state/email"

// Store
import store from "@/store"

const resetPassword =
	async (): Promise<ContactResetPasswordResponseDTO | null> => {
		const returnUrl = `${window.location.origin}/account/login`
		let response: ContactResetPasswordResponseDTO | null = null
		try {
			const dto: ContactResetPasswordDTO = {email: email.value, returnUrl}
			response = await store.dispatch("auth/resetPassword", dto)
			return response
		} catch (err) {
			console.error(err)
		}
		return response
	}

export default resetPassword
